<template>
  <div>
    <select
      :value="selectedPriceDisplayMode"
      class="price-display-mode"
      name="priceMode"
      @change="changePriceDisplayMode($event)"
    >
      <option
        v-for="mode in priceDisplayModes"
        :key="mode.value"
        :value="mode.value"
        :selected="mode.value == quotePriceDisplayMode"
      >
        {{ mode.textValue }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import priceDisplayMode from '@/helpers/enums/priceDisplayMode'

export default {
  data() {
    return {
      priceDisplayModes: [
        priceDisplayMode.including,
        priceDisplayMode.excluding,
        priceDisplayMode.including_and_excluding,
      ],
    }
  },
  computed: {
    ...mapGetters({ quotePriceDisplayMode: 'quote/priceDisplayMode' }),
    selectedPriceDisplayMode() {
      if (!!this.quotePriceDisplayMode) {
        let filteredModes = this.priceDisplayModes.filter(
          (mode) => mode.value == this.quotePriceDisplayMode
        )
        if (filteredModes.lenght > 0) return filteredModes[0]
      }
      return this.defaultPriceDisplayMode
    },
    defaultPriceDisplayMode() {
      return priceDisplayMode.including
    },
  },
  methods: {
    ...mapActions({ setPriceDisplayMode: 'quote/setPriceDisplayMode' }),
    changePriceDisplayMode(event) {
      let newPriceDisplayMode = event.target.value
      this.setPriceDisplayMode(newPriceDisplayMode)
    },
  },
}
</script>
<style lang="scss" scoped>
.price-display-mode {
  width: 20px;
  background-color: $color-primary;
  color: $white;
  padding: 0;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-repeat: no-repeat;
  background-position-x: 50%;
  background-position-y: 50%;
  background-image: url("data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");

  option {
    background-color: $white;
    color: $text-color;
  }
}
</style>
